<template>
    <div class="menu">
        <!-- default-active="0" -->
        <el-menu
       
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        background-color="#fff"
        text-color="#000"
        active-text-color="#00a8a8">
            <el-menu-item index="0" @click="ClickArry()">全部</el-menu-item>
            <el-menu-item v-for="item,index in maintypeData" :key="index" :index="index+1" @click="getListarticle(item)">
                <!-- <i class="el-icon-menu"></i> -->
                <span slot="title">{{ item.cate_name }}</span>
            </el-menu-item>
         
        </el-menu>
    </div>
</template>
<script>
  export default{
    props: ['currentChange'],
    data(){
        return{
            cate_values: ['maintype','industry'],
            maintypeData:[],
            listarticle: [],
            channel: 'policy',
            maintype_ids: ''
        }
    },
    watch: {
        listarticle(newValue, oldValue) {
            console.log("cing");
            console.log(newValue);
            this.$emit('ListArticle', newValue);
        },
        currentChange(newValue,oldValue){
            console.log("点击换页");
            console.log(newValue);
            const data = {
                channel: this.channel,
                pageNum: newValue,
                pageSize: 20,
                maintype_ids: this.maintype_ids,
                keywords: ''
            }
            this.getListArry(data)
        },
        maintype_ids(newValue,oldValue){
            this.$emit("maintypeIds",newValue)
        }
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
        console.log("1");
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
        console.log("2");
      },
      getListarticle(item){
        console.log(item);
        // this.channel = ''
        this.maintype_ids = ''
        // this.channel = item.cate_value
        this.maintype_ids = item.cate_id
        
        const data = {
            channel: this.channel,
            pageNum: 1,
            pageSize: 20,
            maintype_ids: this.maintype_ids,
            keywords: ''
        }
        this.getListArry(data)
      },
      getListArry(data){
        this.$store.dispatch('menu/getMenu',data)
            .then(res => {
                console.log(res);
                if(res.ok){
                    this.listarticle = res.data
                }
            }).catch(err => {
                console.log(err);
            })
      },
      ClickArry(){
        const data = {
            channel: 'policy',
            pageNum: 1,
            pageSize: 20,
            maintype_ids: '',
            keywords: '',
        }
        this.getListArry(data)
      },
    },
    mounted(){
        const data = {
            pageNum: 1,
            pageSize: 999999,
            cate_values: this.cate_values
        }
        this.$store.dispatch('menu/menuList', data)
            .then((res) => {
                console.log(res);
                this.maintypeData = []
                if(res.ok){
                    const list = res.data.items
                    list.forEach(item => {
                        if(item.p_cate_value == 'maintype'){
                            this.maintypeData.push(item)
                        }
                    });
                }
               
            })
            .catch((err) => {
                
                console.log(err);
            }) 
        const listArry = {
            channel: this.channel,
            pageNum: 1,
            pageSize: 20,
            maintype_ids: '',
            keywords: ''
        }
        this.getListArry(listArry)
    }
  }
</script>
<style scoped>
.menu{
    width: 250px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    align-self: flex-start;
    text-align: center;
}

.el-menu-item {
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 18px;
}
.el-menu-item.is-active {
  background-color: rgba(0,168,168,.1) !important;
}
.el-menu-item:hover{
    background-color: rgba(0,168,168,.1) !important;

}
</style>